export const initialState = (inputResponse: any, isEdit = false) => {
  return {
    emp_type: { value: inputResponse.emp_type ?? "", error: "" },
    department: { value: inputResponse.department ?? "", error: "" },
    designation: { value: inputResponse.designation ?? "", error: "" },
    joining: { value: inputResponse.joining ?? "", error: "" },
    role_id: { value: inputResponse.role_name ?? '', id: inputResponse.role_id ?? '', error: '' },
    team_id: { value: inputResponse.team_name ?? '', id: inputResponse.team_id ?? '', error: '' },
    reporting_manager: { value: inputResponse.reporting_manager_name ?? '', id: inputResponse.reporting_manager ?? '', error: '' },
    working_days: { value: inputResponse.working_days?.split(",") ?? [], error: "" },
    working_shift: { value: inputResponse.working_shift?.split(",") ?? [], error: "" },
    id: { value: inputResponse._id ?? "", error: "" },
  };
};

export const handleValidation = (rawInput: any) => {
  if (rawInput.organizationId.value === "") {
    rawInput.organizationId.error = "Please enter a valid organization ID";
  }
  if (rawInput.companyname.value === "") {
    rawInput.companyname.error = "Please enter a valid company name";
  }
  if (rawInput.brandname.value === "") {
    rawInput.brandname.error = "Please enter a valid brand name";
  }
  if (rawInput.country_id.value === "") {
    rawInput.country_id.error = "Please enter a valid country ID";
  }
  return rawInput;
};

export const validateInput = (name: string, value: string) => {
  if (name === "organizationId") {
    if (!/^[a-zA-Z0-9]+$/.test(value) || value.length > 10) {
      return false;
    }
  }
  if (name === "companyname" || name === "brandname") {
    if (!/^[a-zA-Z0-9\s]+$/.test(value) || value.length > 30) {
      return false;
    }
  }
  if (name === "country_id" || name === "state_id") {
    if (!/^[a-zA-Z]+$/.test(value) || value.length > 2) {
      return false;
    }
  }
  if (name === "currency" || name === "country_code" || name === "time_zone") {
    if (!/^[a-zA-Z]+$/.test(value) || value.length > 3) {
      return false;
    }
  }
  if (name === "city") {
    if (!/^[a-zA-Z\s]+$/.test(value) || value.length > 30) {
      return false;
    }
  }
  if (name === "address1" || name === "address2") {
    if (!/^[a-zA-Z0-9\s.,-]+$/.test(value) || value.length > 100) {
      return false;
    }
  }
  if (name === "zipcode") {
    if (!/^[0-9]+$/.test(value) || value.length > 6) {
      return false;
    }
  }

  return true;
};

export const getFinalBodyStructure = (inputBody: any) => {
  let finalBody = {};
  for (const key in inputBody) {

    finalBody = { ...finalBody, [key]: ['role_id', 'team_id', 'reporting_manager'].includes(key) ? inputBody[key].id || 'NA' : inputBody[key].value };
  }
  const newObj: any = { ...finalBody };

  // newObj.organizationId = userId;

  // ["updatedAt", "__v", "createdAt"].forEach((key: any) => delete newObj[key]);

  newObj.working_days = newObj.working_days.join(",");
  newObj.working_shift = newObj.working_shift.join(",");

  return newObj;
};
